import {birdsData} from "./birds-data.js";
import {descrBtn, audioInDescription} from './bird-descr.js';
import {birdsObjectsIndex} from './random.js';

const progressCont = document.querySelector('.container-progress'),
      progress = document.querySelector('.container-progress__progress'),
      imgSrc = document.querySelector('.button-play__img'),
      audio = document.querySelector('.audio'),
      range = document.getElementById('range'),
      volumeImg = document.querySelector('.volume-change__img');

const birdsObjects = [];

let playBtn = document.querySelector('.button-play');
let player = document.querySelector('.bird-data');

for (let matrixString = 0; matrixString < birdsData.length; matrixString++) {
  for (let matrixColumn = 0; matrixColumn < birdsData[matrixString].length; matrixColumn++) {
    birdsObjects.push(birdsData[matrixString][matrixColumn])
  }
}

function loadSong (bird) {
  if (audio === null) return;
  audio.src = bird.audio;
  // console.trace(bird);
}

// loadSong(birdsObjects[birdsObjectsIndex]);

function playAudio (controllerBtn, contollerAudio) {
  controllerBtn.classList.add('play');
  contollerAudio.play ();
  controllerBtn.src = './assets/icon/quiz-page/pause_circle_FILL0_wght400_GRAD0_opsz48.png';
  
}

function pauseAudio (controllerBtn, contollerAudio) {
  controllerBtn.classList.remove('play');
  contollerAudio.pause ();
  controllerBtn.src = './assets/image/for-html/play_circle.png';
}

if (playBtn !== null) {
  playBtn.addEventListener('click', () => {
    const isPlaying = imgSrc.classList.contains('play');
  
    if (isPlaying) {
      pauseAudio (imgSrc, audio);
    } else {
      if (descrBtn.classList.contains('play')) {
        pauseAudio(descrBtn, audioInDescription);
      }
      playAudio (imgSrc, audio);
    }
  })
}

function updateProgress (event) {
  const duration = event.srcElement.duration, 
        currentTime = event.srcElement.currentTime,
        progressPercent = currentTime / duration * 100;
        
        progress.style.width = `${progressPercent}%`;
}

if (audio !== null) {
  audio.addEventListener('timeupdate', updateProgress);
}

function setProgress (event) {
  const width = this.clientWidth,
        clickX = event.offsetX,
        duration = audio.duration;

        audio.currentTime = clickX / width * duration;
}

if (progressCont !== null) {
  progressCont.addEventListener('click', setProgress);
}

function endedAudio (controllerBtn, currentAudio, ) {
  if (currentAudio !== null) {
    currentAudio.addEventListener('ended', () => {
      pauseAudio(controllerBtn, currentAudio)
    });
  }
}

endedAudio (imgSrc, audio);

volumeImg.src = './assets/icon/quiz-page/volume_up.png'

volumeImg.onclick = function () {
  let isVisible = range.classList.contains('visible');
  if (isVisible) {
    range.style.display = 'none';
    range.classList.remove('visible');
  } else {
    range.style.display = 'block';
    range.classList.add('visible');
  }

}

function volumeControl () {
  audio.volume = range.value / 100;
  audioInDescription.volume = range.value / 100;

  if (range.value == 0) {
    volumeImg.src = './assets/icon/quiz-page/volume_mute.png'
  } else if (range.value < 50) {
    volumeImg.src = './assets/icon/quiz-page/volume_down.png'
  } else {
    volumeImg.src = './assets/icon/quiz-page/volume_up.png'
  }
}

range.addEventListener('change', volumeControl);

export {playAudio, pauseAudio, endedAudio, audio, imgSrc, loadSong, progress, range};